module.exports = __webpack_public_path__ + "img/home_logo@2x.2d33f465.png";